import React from 'react';
import { LayoutProps } from './types';

const ClassicLayout = React.lazy(() => import('./ClassicLayout').then(m => ({ default: m.ClassicLayout })));
const RomanticLayout = React.lazy(() => import('./RomanticLayout').then(m => ({ default: m.RomanticLayout })));
const ElegantLayout = React.lazy(() => import('./ElegantLayout').then(m => ({ default: m.ElegantLayout })));
const LuxuryLayout = React.lazy(() => import('./LuxuryLayout').then(m => ({ default: m.LuxuryLayout })));
const NaturalLayout = React.lazy(() => import('./NaturalLayout').then(m => ({ default: m.NaturalLayout })));
const TraditionalLayout = React.lazy(() => import('./TraditionalLayout').then(m => ({ default: m.TraditionalLayout })));

const layoutRegistry: Record<string, React.LazyExoticComponent<React.FC<LayoutProps>>> = {
  classic: ClassicLayout,
  romantic: RomanticLayout,
  elegant: ElegantLayout,
  luxury: LuxuryLayout,
  natural: NaturalLayout,
  traditional: TraditionalLayout,
};

export function getLayoutComponent(style: string): React.LazyExoticComponent<React.FC<LayoutProps>> {
  return layoutRegistry[style] || ClassicLayout;
}

export type { LayoutProps } from './types';
